import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { subscribeToAlert } from '../../../../redux/actions'

// MaterialUI
import {
  Grid, Typography, Button, Tooltip,
  Accordion, AccordionDetails, AccordionSummary,
  List, ListItem, ListItemText
} from '@material-ui/core'

// Icons
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import LibraryAddIcon from '@material-ui/icons/LibraryAdd'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import { OUAlertSelectionModal } from '../../modals'

// This tab is for the alerts authored by the user only. They can be edited and deleted by the user
const UserOnlyAlerts = (props) => {
  const dispatch = useDispatch()
  const {
    classes, unitAlertInfo, GreenCheckbox, truncateText, handleDelete, formDataSet, setEditing,
    TreeData, selectedKeys, fireSubscribeSuccess, fireSubscribeFailure, unSubscribeAlert, noSMS
    // smsDisabled,
  } = props

  // This is used and needed in the MUI tabs

  const orgSupervisors = useSelector(state => state.orgContacts.availableContacts)

  // Opens the OU modal
  const [openUnits, setOpenUnits] = useState(false)
  const [noUnit, setNoUnit] = useState(false)
  const [noDeliveryMethod, setNoDeliveryMethod] = useState(false)

  // Temporary object holding the information for the OU modal to dispatch
  const baseUnitObject = {
    emailNotificationID: '',
    selectedUnits: [],
    sendSMS: false,
    sendEmail: false,
    isSubscribed: false
  }

  const [newUnitAlerts, setNewUnitAlerts] = useState(baseUnitObject)
  // Storing alert selected for unit adding/deleting logic
  const [targetAlert, setTargetAlert] = useState({})

  const [supervisorList, setSupervisorList] = useState([])

  // This will check to see if the alert has been subscribed to and if it has had a OU chosen for it or not and render the correct icon
  const checkOUStatus = (emailNotificationID) => {
    if (newUnitAlerts) {
      // Checks for the alert in the supervisor alerts
      const alertInfo = unitAlertInfo.supervisor.find((orgInfo) => orgInfo.emailNotificationID === emailNotificationID)
      // Gets that specific Alert

      // Checks to see if the alert is in the in the unit array, meaning they have selected this alert previosuly
      if (alertInfo) {
        if (alertInfo.subscribed.isSubscribed) {
          return (
            <PlaylistAddCheckIcon
              className={classes.unitIcon}
              color='primary'
              size='small'
              classes={{ colorPrimary: classes.blueText }}
              onClick={(event) => { event.stopPropagation(); handleClickOpen(alertInfo) }}
            />
          )
        } else {
          return (
            <LibraryAddIcon
              className={classes.unitIcon}
              classes={{ colorPrimary: classes.greenText }}
              color='primary' size='small'
              onClick={(event) => { event.stopPropagation(); handleClickOpen(alertInfo) }}
            />
          )
        }
      }
    }
  }

  // Passes in the alert information to the OU modal
  const handleClickOpen = (alertInfo) => {
    setNewUnitAlerts({
      ...newUnitAlerts,
      emailNotificationID: alertInfo.emailNotificationID,
      selectedUnits: alertInfo.subscribed.units.map((unitInfo) => unitInfo.unitID),
      sendSMS: alertInfo.subscribed.sendSMS,
      sendEmail: alertInfo.subscribed.sendEmail,
      isSubscribed: alertInfo.subscribed.isSubscribed
    })
    setTargetAlert({ ...alertInfo.subscribed })
    setOpenUnits(true)
  }

  // The cancel button handler in the OU modal
  const handleOUCancel = () => {
    setNoDeliveryMethod(false)
    setNoUnit(false)
    setNewUnitAlerts(baseUnitObject)
    setOpenUnits(false)
  }

  // Handles the ok button in the OU modal
  const handleOUOk = () => {
    // !!TODO: this may need to handle diffrently if the org does not have SMS enabled
    if (!newUnitAlerts.selectedUnits.length && newUnitAlerts.isSubscribed) {
      setNoDeliveryMethod(false)
      setNoUnit(true)
    } else if (!newUnitAlerts.selectedUnits.length && !newUnitAlerts.isSubscribed) {
      setNoUnit(false)
      setNoDeliveryMethod(true)
    } else {
      const [unitID] = selectedKeys
      const unitsToDelete = []

      targetAlert.units.forEach((targetUnitInfo) => {
        if (newUnitAlerts.selectedUnits.findIndex((selectedUnit) => selectedUnit === targetUnitInfo.unitID) === -1) {
          unitsToDelete.push(targetUnitInfo.unitID)
        }
      })

      const subscription = {
        emailNotificationID: newUnitAlerts.emailNotificationID,
        unitsToAdd: [...newUnitAlerts.selectedUnits],
        unitsToDelete: [...unitsToDelete],
        sendSMS: newUnitAlerts.sendSMS,
        sendEmail: newUnitAlerts.sendEmail,
        isSubscribed: newUnitAlerts.isSubscribed
      }

      dispatch(subscribeToAlert(unitID, subscription, handleSubscriptionSuccess, fireSubscribeFailure))
    }
  }

  const handleSubscriptionSuccess = () => {
    fireSubscribeSuccess()
    setNewUnitAlerts(baseUnitObject)
    setOpenUnits(false)
  }

  useEffect(() => {
    // Takes the supervisor list and makes an array of objects with only the needed information
    if (orgSupervisors) {
      if (orgSupervisors.length !== 0) {
        const tempList = []
        orgSupervisors.forEach((supervisor) => {
          tempList.push({ supervisorID: supervisor.supervisorID, firstName: supervisor.firstName, lastName: supervisor.lastName })
        })
        setSupervisorList(tempList)
      }
    }
  }, [orgSupervisors])

  // Uses the supervisorID supplied from the alert object to find the readable name to display
  const findAuthorName = (supervisor) => {
    if (supervisorList && supervisorList.length !== 0) {
      const index = supervisorList.findIndex(x => x.supervisorID === supervisor)
      return supervisorList[index] ? `${supervisorList[index]?.firstName} ${supervisorList[index]?.lastName}` : 'User Unavailable'
    }
  }

  return (
    <>
      {/* This is the OU modal */}
      <OUAlertSelectionModal
        openUnits={openUnits}
        handleOUCancel={handleOUCancel}
        handleOUOk={handleOUOk}
        classes={classes}
        GreenCheckbox={GreenCheckbox}
        newUnitAlerts={newUnitAlerts}
        setNewUnitAlerts={setNewUnitAlerts}
        noSMS={noSMS}
        TreeData={TreeData}
        noUnit={noUnit}
        noDeliveryMethod={noDeliveryMethod}
      />

      <Grid container justify='center' className={classes.accordionroot}>
        <Grid item xs={12}>
          {unitAlertInfo && unitAlertInfo.supervisor.length !== 0
            ? (
              unitAlertInfo.supervisor.map((unit) => {
                return (
                  <Accordion key={`alert-number${unit.emailNotificationID}`} elevation={3}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-label='Expand'
                      aria-controls='additional-actions1-content'
                      classes={{ content: classes.AccSumm }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography className={classes.heading} style={{ color: !unit.subscribed.isSubscribed ? '#5291fc' : '#A4D164' }}>Title:</Typography>
                        <Tooltip title={`${unit.emailNotificationName}`} placement='top' arrow enterDelay={500} enterNextDelay={500}>
                          <Typography className='ml-1' style={{ textTransform: 'none' }}>{truncateText(`${unit.emailNotificationName}`)}</Typography>
                        </Tooltip>
                      </div>
                      <div style={{ flexBasis: '33.33%', textAlign: 'center' }} className={classes.secondaryHeading}>
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly' }}>
                          <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                            <Typography variant='caption' style={{ textTransform: 'none', textDecoration: 'underline' }}>
                              Subscribe
                            </Typography>
                            {checkOUStatus(unit.emailNotificationID)}
                          </div>
                          <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center' }}>
                            <Tooltip title='Edit'>
                              <EditIcon size='small' onClick={(e) => { e.preventDefault(); formDataSet(unit); setEditing(true) }} />
                            </Tooltip>
                          </div>
                          <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center' }}>
                            <Tooltip title='Delete'>
                              <DeleteIcon size='small' onClick={(e) => { e.stopPropagation(); handleDelete(unit.unitID, unit.emailNotificationID, 'false') }} />
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accDeets}>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                        <Typography variant='subtitle1' style={{ textTransform: 'none', fontWeight: 'bold' }}>
                          Alert Details:
                        </Typography>
                        {
                          unit.clonedAlert === 1 && <Typography variant='subtitle2' style={{ textTransform: 'none' }}>LearnSafe Preferred Customized Alert</Typography>
                        }
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography variant='caption' className={classes.secondaryHeading}>Author:</Typography>
                          <Typography variant='caption' className={`${classes.secondaryHeading} ml-1`} gutterBottom style={{ textTransform: 'none' }}>
                            {findAuthorName(unit.author)}
                          </Typography>
                        </div>
                        {unit.type === 'S' &&
                          <div style={{ flexDirection: 'column', display: 'flex' }}>
                            <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                              Severity:
                            </Typography>
                            <Typography variant='caption' style={{ textTransform: 'none' }}>
                              {`${unit.minSeverity} - ${unit.maxSeverity}`}
                            </Typography>
                          </div>}
                        <div style={{ flexDirection: 'column', display: 'flex' }}>
                          <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                            Description:
                          </Typography>
                          <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                            {`${unit.emailNotificationDesc}`}
                          </Typography>
                        </div>
                        <div>
                          <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flexDirection: 'column', display: 'flex' }}>
                              <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                Category:
                              </Typography>
                              <List dense className={classes.listRoot}>
                                {unit.categories.length && unit.categories.length !== 0
                                  ? (
                                    unit.categories.map((category) => {
                                      return (
                                        <ListItem
                                          key={`${unit.emailNotificationID} category number ${unit.categories.indexOf(category)}`}
                                          className={classes.listItem}
                                        >
                                          <ListItemText
                                            className={classes.listItemText}
                                            primary={
                                              <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                {`${category}`}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )
                                    })
                                  )
                                  : (
                                    <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                      N/A
                                    </Typography>
                                  )}
                              </List>
                            </div>
                            {
                              !unit.clonedAlert && (
                                <div style={{ flexDirection: 'column', display: 'flex' }}>
                                  <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                    Phrases:
                                  </Typography>
                                  <List dense className={classes.listRoot}>
                                    {unit.words.length && unit.words.length !== 0
                                      ? (
                                        unit.words.map((word) => {
                                          return (
                                            <ListItem
                                              key={`${unit.emailNotificationID} word number ${unit.words.indexOf(word)}`}
                                              className={classes.listItem}
                                            >
                                              <ListItemText
                                                className={classes.listItemText}
                                                primary={
                                                  <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                    {`${word}`}
                                                  </Typography>
                                                }
                                              />
                                            </ListItem>
                                          )
                                        })
                                      )
                                      : (
                                        <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                          N/A
                                        </Typography>
                                      )}
                                  </List>
                                </div>
                              )
                            }
                            <div style={{ flexDirection: 'column', display: 'flex' }}>
                              <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                Workstation:
                              </Typography>
                              <List dense className={classes.listRoot}>
                                {unit.workstations.length && unit.workstations.length !== 0
                                  ? (
                                    unit.workstations.map((workstation) => {
                                      return (
                                        <ListItem
                                          key={`${unit.emailNotificationID} workstation number ${unit.workstations.indexOf(workstation)}`}
                                          className={classes.listItem}
                                        >
                                          <ListItemText
                                            className={classes.listItemText}
                                            primary={
                                              <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                {`${workstation}`}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )
                                    })
                                  )
                                  : (
                                    <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                      N/A
                                    </Typography>
                                  )}
                              </List>
                            </div>
                          </div>
                          <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flexDirection: 'column', display: 'flex' }}>
                              <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                User:
                              </Typography>
                              <List dense className={classes.listRoot}>
                                {unit.users.length && unit.users.length !== 0
                                  ? (
                                    unit.users.map((user) => {
                                      return (
                                        <ListItem
                                          key={`${unit.emailNotificationID} user number ${unit.users.indexOf(user)}`}
                                          className={classes.listItem}
                                        >
                                          <ListItemText
                                            className={classes.listItemText}
                                            primary={
                                              <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                {`${user}`}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )
                                    })
                                  )
                                  : (
                                    <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                      N/A
                                    </Typography>
                                  )}
                              </List>
                            </div>
                          </div>
                          {
                            unit.subscribed.isSubscribed === true
                              ? (
                                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                                  <Button
                                    variant='contained'
                                    size='small'
                                    className={classes.greenBtn}
                                    onClick={() => { unSubscribeAlert(unit.emailNotificationID) }}
                                  >
                                    Unsubscribe
                                  </Button>
                                </div>
                              ) : (
                                <>
                                </>
                              )
                          }
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                )
              })
            )
            : (
              <Grid container justify='center' className='mt-5'>
                <Typography gutterBottom variant='h5' className={classes.secondaryHeading} style={{ textTransform: 'none' }}>You Have Not Created Any Alerts.</Typography>
              </Grid>
            )}
        </Grid>
      </Grid>
    </>
  )
}

export default UserOnlyAlerts
